export default {
  namespaced: true,
  state: {
    tmpUserData: {},
  },
  mutations: {
    SET_TMP_USERDATA(state, payload) {
      state.tmpUserData = payload
    },
  },
}
